import { render, staticRenderFns } from "./SupercardFormatForm.vue?vue&type=template&id=5568d282&"
import script from "./SupercardFormatForm.vue?vue&type=script&lang=js&"
export * from "./SupercardFormatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports